var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBetaBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 13,
    viewBox: "0 0 39 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 13,
    rx: 6.5,
    fill: "#ACDAFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.72 6.088C13.0293 6.18933 13.2747 6.36 13.456 6.6C13.6373 6.83467 13.728 7.128 13.728 7.48C13.728 7.96533 13.5413 8.34133 13.168 8.608C12.7947 8.86933 12.2507 9 11.536 9H8.752V3.4H11.376C12.0373 3.4 12.5467 3.53067 12.904 3.792C13.2613 4.048 13.44 4.40267 13.44 4.856C13.44 5.13333 13.376 5.37867 13.248 5.592C13.12 5.80533 12.944 5.97067 12.72 6.088ZM9.792 4.216V5.76H11.264C11.6267 5.76 11.904 5.696 12.096 5.568C12.2933 5.43467 12.392 5.24267 12.392 4.992C12.392 4.736 12.2933 4.544 12.096 4.416C11.904 4.28267 11.6267 4.216 11.264 4.216H9.792ZM11.472 8.184C12.2773 8.184 12.68 7.91467 12.68 7.376C12.68 6.83733 12.2773 6.568 11.472 6.568H9.792V8.184H11.472ZM19.0379 8.128V9H14.8379V3.4H18.9259V4.272H15.8779V5.728H18.5819V6.584H15.8779V8.128H19.0379ZM21.3333 4.28H19.4773V3.4H24.2293V4.28H22.3733V9H21.3333V4.28ZM28.3606 7.704H25.5606L25.0086 9H23.9366L26.4566 3.4H27.4806L30.0086 9H28.9206L28.3606 7.704ZM28.0166 6.888L26.9606 4.44L25.9126 6.888H28.0166Z",
    fill: "#2588F3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBetaBlue);
export default __webpack_public_path__ + "static/media/beta_blue.ce63481981fa3faa0733a6d831f7aef2.svg";
export { ForwardRef as ReactComponent };